import { createAsyncThunk } from '@reduxjs/toolkit';
import type { LicenseNode } from '@syfo/types/adviser.types';

interface UpdateAdviserLicenseParams {
  uuid: string;
  license: LicenseNode;
}

interface UpdateAdviserLicenseResponse {
  message: string;
}

/**
 * Update adviser license information
 */
export const updateAdviserLicenseThunk = createAsyncThunk<
  UpdateAdviserLicenseResponse,
  UpdateAdviserLicenseParams
>(
  'advisers/updateLicense',
  async ({ uuid, license }) => {
    console.log(`[Advisers] Updating license for adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/license`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(license)
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to update adviser license: ${response.status}`);
    }

    const result: UpdateAdviserLicenseResponse = await response.json();
    console.log('[Advisers] License updated successfully');
    
    return result;
  }
);
